"use client";
import { BLOG_DIR } from "@/lib/env";
import { Pagination } from "@silversea-ssc/ui-components-react";
import { usePathname, useSearchParams } from "next/navigation";
import React, { useCallback } from "react";
import { usePagination } from "react-instantsearch";

type Props = {
  dark?: boolean;
};

const AlgoliaPagination: React.FC<Props> = ({ dark = false }) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { nbPages, currentRefinement, refine } = usePagination();

  const _onClick = useCallback(
    (page: number) => {
      refine(page - 1);
    },
    [refine]
  );

  const _getHref = useCallback(
    (page: number) => {
      if (page == 0) return "#";
      if (page > nbPages) return "#";

      const params = new URLSearchParams(searchParams.toString());
      params.set("page", String(page));
      return `/${BLOG_DIR}${pathname}?${params.toString()}`;
    },
    [pathname, searchParams, nbPages]
  );

  if (nbPages <= 1) return null;

  return (
    <Pagination
      currentPage={currentRefinement + 1}
      onClick={_onClick}
      totalPages={nbPages}
      length={7}
      darkMode={dark}
      getHref={_getHref}
    />
  );
};

export default AlgoliaPagination;
